module.exports = __webpack_public_path__ + "img/20200512_162755.416e02f3.jpg";